import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
export interface ManageAccessGenericSignature {
    Element: HTMLElement;
    Blocks: {
        default?: [];
    };
}
export default class ManageAccessGenericComponent extends Component<ManageAccessGenericSignature> {
    static{
        template(`
    {{! template-lint-disable no-yield-only }}
    {{yield}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        ManageAccessGenericComponent: typeof ManageAccessGenericComponent;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci9hY3Rpb25zLXJ1bm5lci9fd29yay9jbG91ZC11aS9jbG91ZC11aS9hZGRvbnMvbWFuYWdlLWFjY2Vzcy9wYWNrYWdlL3NyYy9jb21wb25lbnRzL21hbmFnZS1hY2Nlc3MvZ2VuZXJpYy5ndHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IENvbXBvbmVudCBmcm9tICdAZ2xpbW1lci9jb21wb25lbnQnO1xuXG5leHBvcnQgaW50ZXJmYWNlIE1hbmFnZUFjY2Vzc0dlbmVyaWNTaWduYXR1cmUge1xuICBFbGVtZW50OiBIVE1MRWxlbWVudDtcbiAgQmxvY2tzOiB7XG4gICAgZGVmYXVsdD86IFtdO1xuICB9O1xufVxuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBNYW5hZ2VBY2Nlc3NHZW5lcmljQ29tcG9uZW50IGV4dGVuZHMgQ29tcG9uZW50PE1hbmFnZUFjY2Vzc0dlbmVyaWNTaWduYXR1cmU-IHtcbiAgPHRlbXBsYXRlPlxuICAgIHt7ISB0ZW1wbGF0ZS1saW50LWRpc2FibGUgbm8teWllbGQtb25seSB9fVxuICAgIHt7eWllbGR9fVxuICA8L3RlbXBsYXRlPlxufVxuXG5kZWNsYXJlIG1vZHVsZSAnQGdsaW50L2Vudmlyb25tZW50LWVtYmVyLWxvb3NlL3JlZ2lzdHJ5JyB7XG4gIGV4cG9ydCBkZWZhdWx0IGludGVyZmFjZSBSZWdpc3RyeSB7XG4gICAgTWFuYWdlQWNjZXNzR2VuZXJpY0NvbXBvbmVudDogdHlwZW9mIE1hbmFnZUFjY2Vzc0dlbmVyaWNDb21wb25lbnQ7XG4gIH1cbn1cbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxlQUFlLHFCQUFxQjtBQUUzQyxpQkFBaUI7SUFDZixTQUFTO0lBQ1Q7UUFDRTs7O0FBSUosZUFBZSxNQUFNLHFDQUFxQyxVQUFVO0lBQ2xFLE1BQUE7UUFBQSxTQUFVLENBQUE7OztFQUdWLENBQUEsRUFBQTtZQUFBLFdBQUEsSUFBVztZQUFYO2dCQUFBLE9BQUEsS0FBQSxTQUFBLENBQUEsRUFBVztZQUFEO1FBQUE7SUFBQSxDQUhBO0FBSVo7ZUFFZTtJQUNiLHlCQUF5QjtRQUN2QixxQ0FBcUMifQ